import axios from 'axios';

const REACT_APP_BACKEND_EVENT_URL = process.env.REACT_APP_BACKEND_EVENT_URL;

export interface NoteItem {
  uuid: string;
  content: string;
  updatedAt: string;
  createdAt: string;
}

export interface CreateNoteRequest {
  content: string;
}

export interface UpdateNoteRequest {
  content: string;
}

export const getNoteList = async (accessToken: string): Promise<NoteItem[]> => {
  try {
    const response = await axios.get(`${REACT_APP_BACKEND_EVENT_URL}/note/${accessToken}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching note list:', error);
    throw error;
  }
};

export const getNoteByUuid = async (accessToken: string, noteUuid: string): Promise<NoteItem> => {
  try {
    const response = await axios.get(`${REACT_APP_BACKEND_EVENT_URL}/note/${accessToken}/${noteUuid}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching note by uuid:', error);
    throw error;
  }
};

export const createNote = async (accessToken: string, data: CreateNoteRequest): Promise<NoteItem> => {
  try {
    const response = await axios.post(`${REACT_APP_BACKEND_EVENT_URL}/note/${accessToken}`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating note:', error);
    throw error;
  }
};

export const updateNote = async (
  accessToken: string, 
  noteUuid: string, 
  data: UpdateNoteRequest
): Promise<NoteItem> => {
  try {
    const response = await axios.put(`${REACT_APP_BACKEND_EVENT_URL}/note/${accessToken}/${noteUuid}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating note:', error);
    throw error;
  }
};

export const deleteNote = async (accessToken: string, noteUuid: string): Promise<void> => {
  try {
    await axios.delete(`${REACT_APP_BACKEND_EVENT_URL}/note/${accessToken}/${noteUuid}`);
  } catch (error) {
    console.error('Error deleting note:', error);
    throw error;
  }
};